import script from "./Details.vue?vue&type=script&setup=true&lang=js"
export * from "./Details.vue?vue&type=script&setup=true&lang=js"

import "./Details.vue?vue&type=style&index=0&id=1eace937&lang=css"

const __exports__ = script;

export default __exports__